export enum AmplitudeEventsBulkCustoms {
    FINISH_CUSTOMS_FORM = 'Finish customs form',
    SKIP_CUSTOMS_FORM = 'skip customs step',
}
